import { render, staticRenderFns } from "./chat-mobile.vue?vue&type=template&id=1a09479e&scoped=true"
import script from "./chat-mobile.vue?vue&type=script&lang=js"
export * from "./chat-mobile.vue?vue&type=script&lang=js"
import style0 from "./chat-mobile.vue?vue&type=style&index=0&id=1a09479e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09479e",
  null
  
)

export default component.exports